import type { EventData, EventType } from '../../../hooks/types';

/**
 * A Event Data for data mutation.
 * @param eventType type of the event.
 * @returns event data.
 */
export const eventData = (eventType: EventType): EventData => ({
  data: { event_type: eventType },
});

/**
 * A query partial for querying Active record data.
 */
export const activeRecord = { record_status: { _eq: 'Active' } };

/**
 * A query partial for querying Deleted record data.
 */
export const deletedRecord = { record_status: { _eq: 'Deleted' } };
